import React from 'react';
import {
  TextField,
  ShowController,
  ShowView,
  SimpleShowLayout,
} from 'react-admin';
import { ShortenedDateField } from '../../common';
import { KST_OFFSET_IN_MIN } from '../../constants';

const PointLogShow = (props) => (
  <>
    <ShowController {...props}>
      {(controllerProps) => (
        <ShowView {...props} {...controllerProps}>
          <SimpleShowLayout>
            <TextField source="contentId" />
            <TextField label="User Id" source="userId" />
            <TextField source="points" />
            <TextField source="status" />
            <ShortenedDateField
              label="Create At"
              source="createdAt.seconds"
              type="timestamp"
              utcOffset={KST_OFFSET_IN_MIN}
            />
          </SimpleShowLayout>
        </ShowView>
      )}
    </ShowController>
  </>
);

export default PointLogShow;
